// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payroll-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top:50px;
}

.payroll-title {
  text-align: center;
  font-size: 24px;
  color: #131111;
  margin-bottom: 20px;
  background-color: transparent!important;
}

.payroll-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-left:55%;
}

.payroll-label {
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
  
}

.payroll-select {
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
 
}

.payslip {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.payslip h2 {
  text-align: center;
  font-size: 20px;
  color: #0c0b0b;
  margin-bottom: 15px;
}

.payslip-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.payslip-table th, 
.payslip-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.payslip-table th {
  background: grey;
  color: #fff;
  font-weight: bold;
}

.payslip-table tr:nth-child(even) {
  background: white;
}

.payslip-table tr.total-row {
  background: white;
  font-weight: bold;
}

.payslip-table tr.net-salary-row {
  font-weight: bold;
}

.payroll-download-btn {
  display: block;
  margin-left:80%;
  width: 20%;
  padding: 12px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background: #28a745;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.payroll-download-btn:hover {
  background: #218838;
}

.error {
  color: red;
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
}



.advance-section {
  margin-top: 2rem;
}

.advance-table {
  width: 100%;
  border-collapse: collapse;
}

.advance-table th,
.advance-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.advance-table th {
  background-color: #f2f2f2;
}
`, "",{"version":3,"sources":["webpack://./src/components/PayrollSummary/PayrollSummary.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".payroll-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n  background: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top:50px;\n}\n\n.payroll-title {\n  text-align: center;\n  font-size: 24px;\n  color: #131111;\n  margin-bottom: 20px;\n  background-color: transparent!important;\n}\n\n.payroll-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-left:55%;\n}\n\n.payroll-label {\n  font-size: 16px;\n  font-weight: bold;\n  margin-right: 10px;\n  \n}\n\n.payroll-select {\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n \n}\n\n.payslip {\n  background: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.payslip h2 {\n  text-align: center;\n  font-size: 20px;\n  color: #0c0b0b;\n  margin-bottom: 15px;\n}\n\n.payslip-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.payslip-table th, \n.payslip-table td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: left;\n}\n\n.payslip-table th {\n  background: grey;\n  color: #fff;\n  font-weight: bold;\n}\n\n.payslip-table tr:nth-child(even) {\n  background: white;\n}\n\n.payslip-table tr.total-row {\n  background: white;\n  font-weight: bold;\n}\n\n.payslip-table tr.net-salary-row {\n  font-weight: bold;\n}\n\n.payroll-download-btn {\n  display: block;\n  margin-left:80%;\n  width: 20%;\n  padding: 12px;\n  margin-top: 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: white;\n  background: #28a745;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.payroll-download-btn:hover {\n  background: #218838;\n}\n\n.error {\n  color: red;\n  text-align: center;\n  font-size: 16px;\n  margin-top: 10px;\n}\n\n\n\n.advance-section {\n  margin-top: 2rem;\n}\n\n.advance-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.advance-table th,\n.advance-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.advance-table th {\n  background-color: #f2f2f2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
